export type BannerFormType = 'showroom' | 'storefront';

export const BANNER_UPLOAD_WIDTH = 1920;

export const BANNER_HEIGHT = 200;

export const BANNER_PLACEHOLDER_BY_TYPE: Record<BannerFormType, string> = {
  showroom: '/images/showroom-banner.svg',
  storefront: '/images/storefront-banner.svg',
};
